import { AHText, TouchableBox } from "arkh";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { useLogout } from "../../OS/Login/useLogin";
import { graphql, useFragment } from "react-relay";
import { OrgLogoutButton_me$key } from "./__generated__/OrgLogoutButton_me.graphql";

export function OrgLogoutButton(props: { me: OrgLogoutButton_me$key }) {
  const intl_tokens = useIntlTokens();
  const logout = useLogout();
  const me = useFragment(
    graphql`
      fragment OrgLogoutButton_me on User {
        name
        email
      }
    `,
    props.me
  );
  return (
    <TouchableBox
      cornerRadius="large"
      borderColor="border-strong"
      style={{
        borderWidth: 1,
        width: "100%",
      }}
      space="medium"
      onPress={logout}
    >
      <AHText type="title-small">{me.name}</AHText>
      <AHText spaceBottom="small" type="detail">
        {me.email}
      </AHText>
      <AHText type="subtitle" color="text-secondary">
        {intl_tokens.LogOut}
      </AHText>
    </TouchableBox>
  );
}
